// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3VBI-","paramInput":"JobSimulator_paramInput__1Pd_k","input":"JobSimulator_input__2Al5I"};